type ConsentPayload = {
  logRocket: boolean
  heap: boolean
}

function OptanonWrapper(): void {
  const activeGroups = window.OnetrustActiveGroups

  if (!activeGroups) {
    return
  }

  const data = document.body.dataset as Record<string, string>

  if (!data) {
    return
  }
  const payload: ConsentPayload = {
    logRocket: activeGroups.includes(data.cookieAnalytical),
    heap: activeGroups.includes(data.cookieAnalytical),
  }

  subscribers.forEach((callback) => {
    callback(payload)
  })
}

const subscribers = new Set<(payload: ConsentPayload) => void>()

export const setup = (): void => {
  // We have to do this unfortunately due to how the API for Optanon is defined
  // Should be ran as early in the JS lifecycle as possible
  window.OptanonWrapper = OptanonWrapper
}

// Interested parties can listen for changes here
export const subscribe = (callback: () => void): void => {
  subscribers.add(callback)
}

// Mechanism for interested parties to stop listening without memory leaks
export const unsubscribe = (callback: () => void): void => {
  subscribers.delete(callback)
}

// General shutdown mechanism
export const teardown = (): void => {
  subscribers.clear()
}
